// extracted by mini-css-extract-plugin
export var section = "_2k-1";
export var topNav = "_2k-0";